"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AdditionalInfo = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useUpdateDeliveryCommentQuery = require("../../api/useUpdateDeliveryCommentQuery");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const COMMENT_MAX_LENGH = 200;
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        borderTop: "1px solid ".concat(theme.palette.grey[200]),
        padding: theme.spacing(3, 0, 4, 0),
        marginTop: theme.spacing(4),
        color: theme.palette.grey.A700
    };
});
const DeliveryCommentHeader = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1)
    };
});
const InfoItem = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'flex-start',
        '& + *': {
            marginTop: theme.spacing(1)
        }
    };
});
const WorkingHoursWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'flex-start',
        '& + *': {
            marginTop: theme.spacing(1)
        }
    };
});
const WorkingHours = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { ownerState: { isDisplayedInMainPage } } = param;
    return {
        ...!isDisplayedInMainPage && {
            ...(0, _shared.lineClampStyles)(2)
        }
    };
});
const ClockIcon = (0, _mui.styled)(_icons.Clock)((param)=>{
    let { theme } = param;
    return {
        marginRight: theme.spacing(2),
        fontSize: '2.1rem'
    };
});
const TelephoneIcon = (0, _mui.styled)(_icons.Telephone)((param)=>{
    let { theme } = param;
    return {
        marginRight: theme.spacing(2),
        fontSize: '2.1rem'
    };
});
const CommentWrapper = (0, _mui.styled)(_mui.Box)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(0, 0, 1, 0),
        padding: theme.spacing(0)
    };
});
const CommentTextField = (0, _mui.styled)(_mui.TextField)(()=>({
        padding: 0,
        width: '100%'
    }));
const AdditionalInfo = (param)=>{
    let { deliveryMethod, deliveryComment, isDisplayedInMainPage = false, telephoneNumber, workingHours, isCommentEnabled } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { comment, updateDeliveryComment } = (0, _useUpdateDeliveryCommentQuery.useUpdateDeliveryCommentQuery)(deliveryComment !== null && deliveryComment !== void 0 ? deliveryComment : '');
    const { formatMessage } = (0, _hooks.useTranslations)();
    const deliveryCommentPlaceholder = formatMessage('optional');
    const onBlurHandler = (0, _react.useCallback)((param)=>{
        let { target: { value } } = param;
        void updateDeliveryComment(value);
    }, [
        updateDeliveryComment
    ]);
    const ownerState = {
        isDisplayedInMainPage
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        ...getTestIdProps(_models.TestId.AdditionalInfoBox),
        children: [
            isDisplayedInMainPage && (Boolean(deliveryComment) || Boolean(isCommentEnabled)) && deliveryMethod === _models.AddressItemDeliveryMethod.Home ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeliveryCommentHeader, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                            id: "messageToTheCourier"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CommentWrapper, {
                        children: isCommentEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CommentTextField, {
                            ...getTestIdProps(_models.TestId.DeliveryCommentTextField),
                            multiline: true,
                            maxRows: 4,
                            placeholder: deliveryCommentPlaceholder,
                            defaultValue: comment,
                            inputProps: {
                                maxLength: COMMENT_MAX_LENGH
                            },
                            onBlur: onBlurHandler
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoItem, {
                            ...getTestIdProps(_models.TestId.MessageToTheCourier),
                            children: deliveryComment
                        })
                    })
                ]
            }) : null,
            deliveryMethod !== _models.AddressItemDeliveryMethod.Home && workingHours ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(WorkingHoursWrapper, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockIcon, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(WorkingHours, {
                        ownerState: ownerState,
                        ...getTestIdProps(_models.TestId.DeliveryWorkingHours),
                        children: workingHours
                    })
                ]
            }) : null,
            isDisplayedInMainPage && telephoneNumber ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InfoItem, {
                ...getTestIdProps(_models.TestId.DeliveryTelephoneNumber),
                "data-di-mask": true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(TelephoneIcon, {}),
                    telephoneNumber
                ]
            }) : null
        ]
    });
};
exports.AdditionalInfo = AdditionalInfo;
